import React from 'react'
import User from 'EurestoClass/User'

import Grid from '@material-ui/core/Grid'
import Avatar from 'Components/Avatar'

import Recherche from 'EurestoComponents/Recherche'
import Search from '../Search'

export default class extends React.Component {

  constructor (props) {
    super(props)
  }

  render () {
    const columns = [
      { Header: 'id', accessor: 'id', show: false },
      {
        Header: () => <span style={{ cursor: 'not-allowed' }}><i className="EurestoPrimary--text ei-module_crm"
                                                                 aria-hidden="true"/></span>,
        id: 'entite',
        sortable: false,
        width: 48,
        Cell: (row) => {
          return (
            <Grid container justify={'center'} alignItems={'center'} alignContent={'center'}
                  direction={'column'} style={{ height: '100%', width: '100%' }}>
              <Avatar
                src={row.original.lien}
                style={{ width: '45px', height: '45px', padding: 5 }}/>
            </Grid>
          )
        },
      }, {
        Header: <span>{EurestoI18n.t('commun:Contact')}</span>,
        accessor: 'contact_libelle',
        minWidth: 100,
        Cell: (row) => {
          return (
            <Grid container justify={'center'} alignItems={'flex-start'} alignContent={'flex-start'}
                  direction={'column'} style={{ height: '100%' }}>
              <span>{row.original.contact_libelle}</span>
            </Grid>
          )
        },
      }, {
        Header: <span>{EurestoI18n.t('commun:Intitulé Carte')}</span>,
        accessor: 'libelle',
        maxWidth: 200,
        Cell: (row) => {
          return (
            <Grid container justify={'center'} alignItems={'center'} alignContent={'center'} direction={'column'}
                  style={{ height: '100%' }}>
              <span>{row.original.libelle}</span>
            </Grid>
          )
        },
      }, {
        Header: <span>{EurestoI18n.t('commun:Codes Barres')}</span>,
        accessor: 'code_barres',
        maxWidth: 200,
        Cell: (row) => {
          return (
            <Grid container justify={'center'} alignItems={'center'} alignContent={'center'} direction={'column'}
                  style={{ height: '100%' }}>
              <span>#{row.original.code_barres}</span>
            </Grid>
          )
        },
      }, {
        Header: <span>{EurestoI18n.t('commun:Points')}</span>,
        accessor: 'points',
        maxWidth: 100,
        Cell: (row) => {
          return (
            <Grid container justify={'center'} alignItems={'center'} alignContent={'center'} direction={'column'}
                  style={{ height: '100%' }}>
              <span>{row.original.points}</span>
            </Grid>
          )
        },
      },

    ]
    return (
      <Recherche
        showSearch={this.props.showSearch}
                           searchComponent={<Search defaultSearch={this.props.defaultSearch}
                                                          search={this.props.search || 'fidelite_' + (this.props.name || '') + User.Entite.get().id}/>}
        view={this.props.view}
        data={this.props.data}
        type={'list'}
        style={this.props.style}
        onClick={this.props.onClick}
        columns={columns}
        search={this.props.search || 'fidelite_' + (this.props.name || '') + User.Entite.get().id}
      />
    )
  }

}



// WEBPACK FOOTER //
// ./app/App/Module/Fidelite/Component/Table/index.js